<template>
  <div class="user">
  <div class="container mt-3">
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h2>
          비밀번호 변경
        </h2>
        <p class="gray">비밀번호를 변경합니다.</p>
      </div>
    </div>

    <el-form :model="frm" :rules="rules" ref="frm" class="demo-form">
      <div class="card-body gray">
        <div class="card-form textarea">
          <el-form-item label="현재 비밀번호" prop="pass">
            <el-input type="password" v-model="frm.pass" :maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="새로운 비밀번호" prop="pass_new">
            <el-input type="password" v-model="frm.pass_new" :maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="새로운 비밀번호 확인" prop="pass_confirm">
            <el-input type="password" v-model="frm.pass_confirm" :maxlength="16"></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="card-body text-right">
        <el-button @click="resetForm('frm')">취소</el-button>
        <el-button type="primary" @click="submitForm('frm')">비밀번호 변경</el-button>
      </div>
    </el-form>
  </div>
  </div>
  </div>
</template>
<script>
import common from '@/modules/common'
export default {
  name: 'CHANGE_PASSWORD',
  mixins: [common.mixins],
  data () {
    const validatePass = (rule, value, callback) => {
      // const passwordPattern = /^(?=.*\d)(?=.*[#$@!%&*?])(?=.*[A-Z])(?=.*[a-z])[A-Za-z\d#$@!%&*?]{8,}$/
      const passwordPattern = /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d#$@!%&*?]{8,16}$/
      if (!passwordPattern.test(value)) {
        callback(new Error('8~16자리의 영문, 숫자 조합으로 사용가능합니다.'))
      } else if (this.frm.pass_confirm !== '') {
        this.$refs.frm.validateField('pass_confirm')
      }
      callback()
    }
    const validatePass2 = (rule, value, callback) => {
      if (value !== this.frm.pass_new) {
        callback(new Error('새로운 비밀번호와 다릅니다. 비밀번호를 확인하십시오.'))
      } else {
        callback()
      }
    }
    return {
      frm: {
        pass: '',
        pass_new: '',
        pass_confirm: ''
      },
      rules: {
        pass: [
          { required: true, message: '현재 비밀번호를 입력하십시오.' },
          { min: 1, max: 16, message: '최소 4자 이상 16자 이내로 입력하십시오.' }
        ],
        pass_new: [
          { required: true, message: '새로운 비밀번호를 입력하십시오.' },
          { min: 8, max: 16, message: '최소 8자 이상 16자 이내로 입력하십시오.' },
          { validator: validatePass }
        ],
        pass_confirm: [
          { required: true, message: '새로운 비밀번호 확인을 입력하십시오.' },
          { min: 8, max: 16, message: '최소 8자 이상 16자 이내로 입력하십시오.' },
          { validator: validatePass2 }
        ]
      },
      pageName: ''
    }
  },
  created () {
    this.pageName = 'MAIN_' + this.$store.getters.user_type
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            password: this.frm.pass,
            password_new: this.frm.pass_new,
            password_confirm: this.frm.pass_confirm
          }
          common.axios.put('/user/password', data)
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('비밀번호가 변경되었습니다.')
                this.$store.dispatch('AUTH_PW_INIT')
                  .then(() => {
                    setTimeout(() => {
                      this.$router.push({name: this.pageName})
                    }, 1000)
                  })
              } else {
                if (Array.isArray(result.message)) {
                  result.message.map(msg => {
                    this.$message.warning(result.message)
                  })
                } else {
                  this.$message.warning(result.message)
                }
              }
            })
        }
      })
    },
    resetForm (formName) {
      // 비밀번호 변경으로 들어온 경우에는 메인으로만 보낸다.
      if (this.$route.params.init_yn && this.$route.params.init_yn === 'N') {
        this.$router.push({name: this.pageName})
      } else {
        // 비밀번호 필수 변경일 경우에는 로그아웃 후 로그인 화면으로 보낸다.
        this.$store.dispatch('AUTH_LOGOUT').then(() => {
          this.$router.push({name: this.pageName})
        })
      }
      // this.$refs[formName].resetFields()
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue